import React, { useEffect, useRef } from 'react';
import { ChevronLeft } from 'lucide-react';
import { SS } from './settingsStyles';

/**
 * One settings screen: a title, a way back, and the content.
 *
 * Remembers where it was scrolled, keyed by name, because coming back from a
 * sub-screen to the top of a long list loses the place a person was working
 * in — and the list of settings is only going to get longer.
 */
export default function SettingsScreen({ title, onBack, right = null, scrollKey, children }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el || !scrollKey) return;
    const saved = Number(sessionStorage.getItem(`vox-scroll:${scrollKey}`) || 0);
    if (saved) el.scrollTop = saved;
    return () => {
      try { sessionStorage.setItem(`vox-scroll:${scrollKey}`, String(el.scrollTop)); } catch (e) {}
    };
  }, [scrollKey]);

  return (
    <div ref={ref} style={{ ...SS.screen, overflowY: 'auto', height: '100%' }}>
      <div style={SS.screenHeader}>
        <button onClick={onBack} style={SS.backBtn} aria-label="Назад">
          <ChevronLeft size={24} />
        </button>
        <div style={SS.screenTitle}>{title}</div>
        {right && <div style={{ marginLeft: 'auto' }}>{right}</div>}
      </div>
      {children}
    </div>
  );
}
